import { useLoadReferenceData } from "../../hooks/useReferenceData";

export const PreloadReferenceData = () => {
  useLoadReferenceData();

  return null;
};

export default PreloadReferenceData;
